import { Component, Input } from '@angular/core';
import { SLEntity, SLEntityOwnedShareItem } from '../entity';
import { Router } from '@angular/router';

@Component({
  selector: 'sl-entity-owned-shares',
  templateUrl: './entity-owned-shares.component.html',
})
export class SLEntityOwnedSharesComponent {

  @Input()
  entity: SLEntity

  constructor(
    private router: Router,
  ) { }

  showEntity(share: SLEntityOwnedShareItem) {
    this.router.navigate(['shares-ledger', 'entities', share.id]);
  }
}
